"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "salisano": {
    "b1b6cd18": [{
      "hkey": "8500c1c1",
      "slug": "salisano",
      "name": "Salisano",
      "primary": true,
      "skipSearch": false
    }],
    "gallo": [{
      "hkey": "8500c1c1",
      "slug": "salisano",
      "name": "Salisano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d3ef0e8d": [{
      "hkey": "8500c1c1",
      "slug": "salisano",
      "name": "Salisano",
      "primary": true,
      "skipSearch": false
    }],
    "roccabaldesca": [{
      "hkey": "8500c1c1",
      "slug": "salisano",
      "name": "Salisano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7fc093bf": [{
      "hkey": "8500c1c1",
      "slug": "salisano",
      "name": "Salisano",
      "primary": true,
      "skipSearch": false
    }],
    "santa-lucia": [{
      "hkey": "8500c1c1",
      "slug": "salisano",
      "name": "Salisano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c8a85f28": [{
      "hkey": "8500c1c1",
      "slug": "salisano",
      "name": "Salisano",
      "primary": true,
      "skipSearch": false
    }],
    "vallocchie": [{
      "hkey": "8500c1c1",
      "slug": "salisano",
      "name": "Salisano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;